.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: var(--ds-stroke-default) solid var(--ds-color-line-default);
  border-radius: var(--ds-radius-icon-btn);
  background: var(--ds-color-bg-page);
  cursor: pointer;
  box-sizing: border-box;
  transition: background-color 0.2s ease;
}

.button > svg {
  flex-shrink: 0;
}

/* Sizes — cuadrado fijo, icono centrado (sin token de dimensión en el DS) */
.button[data-size="xs"] {
  width: 20px;
  height: 20px;
}

.button[data-size="sm"] {
  width: 32px;
  height: 32px;
}

.button[data-size="md"] {
  width: 40px;
  height: 40px;
}

/* Colors — el icono hereda el color vía currentColor */
.button[data-color="primary"] {
  color: var(--ds-color-text-hi);
}

.button[data-color="error"] {
  color: var(--ds-color-status-bad);
}

.button:hover:not(:disabled) {
  background: var(--ds-color-bg-elev-2);
}

.button:focus-visible {
  outline: var(--ds-stroke-focus) solid var(--ds-color-accent-primary);
  outline-offset: 2px;
}

.button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.button[data-spinning="true"] > svg {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .button[data-spinning="true"] > svg {
    animation: none;
  }
}
